module.exports = __webpack_public_path__ + "img/username-active.c06de59b.svg";